import classNames from "classnames";
import css from "./index.module.scss";
import emptyImg from "@/assets/images/no-data.png";
import searchEmptyImg from "@/assets/images/search-empty.png";
import notfoundImg from "@/assets/images/404.png";

type ResultType = "empty" | "search-empty" | "404";

type ResultProps = {
  type?: ResultType;
  className?: string;
  style?: React.CSSProperties;
  image?: string;
  description?: React.ReactNode;
};

const result: Record<ResultType, { image: string; description: string }> = {
  empty: {
    image: emptyImg,
    description: "No data found."
  },
  "search-empty": {
    image: searchEmptyImg,
    description: "No results found."
  },
  "404": {
    image: notfoundImg,
    description: "Error 404: Not Found"
  }
};

const Result: React.FC<ResultProps> = ({ type = "empty", className, style, image, description }) => {
  return (
    <div className={classNames(css.result, className)} style={style}>
      <img src={image ? image : result[type].image} width={396} height={396} />
      <div className={css.tip}>{description ?? result[type].description}</div>
    </div>
  );
};

export default Result;
